import { toast } from 'react-hot-toast'
import { Header, Text, Title, Wrapper } from './Notification.styles'
import { NotificationType } from '@big-red-group/storefront-common-ui'

type NotificationProps = {
  text: string
  title: string
  type: NotificationType
}

const Notification: React.FC<NotificationProps> = ({ text, title, type }) => {
  return (
    <Wrapper type={type} data-testid={`notification-${type}`}>
      <Header>
        <div>
          {/* Info icon */}
          <svg width="22" height="22" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 16.5C0 7.66343 7.16345 0.5 16 0.5C24.8365 0.5 32 7.66343 32 16.5C32 25.3365 24.8365 32.5 16 32.5C7.16344 32.5 0 25.3365 0 16.5ZM16 3.16667C8.63621 3.16667 2.66667 9.13619 2.66667 16.5C2.66667 23.8638 8.63621 29.8334 16 29.8334C23.3638 29.8334 29.3333 23.8638 29.3333 16.5C29.3333 9.1362 23.3638 3.16667 16 3.16667Z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 13.832C12 13.0957 12.597 12.4987 13.3333 12.4987H15.3333C15.8638 12.4987 16.3724 12.7094 16.7475 13.0843C17.122 13.4592 17.3333 13.9682 17.3333 14.4987L17.3333 23.1654L19.3333 23.1654C20.0697 23.1654 20.6667 23.7623 20.6667 24.4987C20.6667 25.2351 20.0697 25.832 19.3333 25.832H17.3333C16.6261 25.832 15.9477 25.551 15.4477 25.051C14.9477 24.551 14.6667 23.8726 14.6667 23.1654V15.1654H13.3333C12.597 15.1654 12 14.5684 12 13.832Z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.6553 10.4987C16.2076 10.4987 16.6553 10.0509 16.6553 9.4987C16.6553 8.94652 16.2076 8.4987 15.6553 8.4987V7.83203C14.7347 7.83203 13.9886 8.57833 13.9886 9.4987C13.9886 10.4191 14.7347 11.1654 15.6553 11.1654V10.4987Z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.6553 7.83203C16.5754 7.83203 17.3219 8.57798 17.3219 9.4987C17.3219 10.4194 16.5754 11.1654 15.6553 11.1654V10.4987C15.1031 10.4987 14.6553 10.0512 14.6553 9.4987C14.6553 8.94617 15.1031 8.4987 15.6553 8.4987V7.83203Z"
            />
          </svg>
          <div>
            <Title data-testid="notification-title">{title}</Title>
            <Text data-testid="notification-text">{text}</Text>
          </div>
        </div>
        {/* Close icon */}
        <svg
          width="18"
          height="18"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => toast.remove()}
          style={{ cursor: 'pointer' }}
          data-testid="notification-close"
        >
          <path
            fill="var(--grey-100)"
            d="M30.2371 4.33708C30.8099 3.76432 30.8099 2.83567 30.2371 2.2629C29.6644 1.69014 28.7357 1.69014 28.163 2.2629L16 14.4258L3.83713 2.2629C3.26436 1.69014 2.33572 1.69014 1.76295 2.2629C1.19018 2.83567 1.19018 3.76432 1.76295 4.33708L13.9259 16.5L1.76295 28.6629C1.19018 29.2357 1.19018 30.1643 1.76295 30.7371C2.33572 31.3099 3.26436 31.3099 3.83713 30.7371L16 18.5742L28.163 30.7371C28.7357 31.3099 29.6644 31.3099 30.2371 30.7371C30.8099 30.1643 30.8099 29.2357 30.2371 28.6629L18.0742 16.5L30.2371 4.33708Z"
          />
        </svg>
      </Header>
    </Wrapper>
  )
}

export default Notification
